import * as tslib_1 from "tslib";
import { DialogMessages, DialogStateResponse, DialogPriceData, DialogVoucherData } from '../../globalTypes';
import { dialogStateActionTypes } from '../store/dialogState/ActionTypes';
var DialogStateFetcher = /** @class */ (function () {
    function DialogStateFetcher() {
        this.xmlHttpRequest = null;
    }
    DialogStateFetcher.getInstance = function () {
        if (!DialogStateFetcher.instance) {
            DialogStateFetcher.instance = new DialogStateFetcher();
            // ... any one time initialization goes here ...
        }
        return DialogStateFetcher.instance;
    };
    DialogStateFetcher.prototype.isLoading = function () {
        return this.xmlHttpRequest !== null;
    };
    DialogStateFetcher.prototype.abortLoading = function () {
        if (this.xmlHttpRequest !== null) {
            this.xmlHttpRequest.abort();
        }
    };
    DialogStateFetcher.prototype.fetchRequest = function (dialogStateRequest) {
        var _this = this;
        var dialogStateFetcher = this;
        return new Promise(function (resolve, reject) {
            var stateError = function () {
                var state = 500;
                if (dialogStateFetcher.xmlHttpRequest !== null) {
                    state = dialogStateFetcher.xmlHttpRequest.status;
                    dialogStateFetcher.xmlHttpRequest = null;
                }
                var reason = state === 0 ?
                    dialogStateActionTypes.NO_CONNECTION_DIALOG_STATE :
                    dialogStateActionTypes.ERROR_DIALOG_STATE;
                reject(reason);
            };
            var stateAborted = function () {
                reject(dialogStateActionTypes.ABORTED_DIALOG_STATE);
            };
            dialogStateFetcher.xmlHttpRequest = new XMLHttpRequest();
            dialogStateFetcher.xmlHttpRequest.open('POST', dialogStateRequest.url);
            dialogStateFetcher.xmlHttpRequest.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            dialogStateFetcher.xmlHttpRequest.onerror = stateError;
            dialogStateFetcher.xmlHttpRequest.onabort = stateAborted;
            dialogStateFetcher.xmlHttpRequest.ontimeout = stateError;
            dialogStateFetcher.xmlHttpRequest.onload = (function () {
                if (dialogStateFetcher.xmlHttpRequest !== null) {
                    if (dialogStateFetcher.xmlHttpRequest.status === 200) {
                        resolve(_this.formatResponse(dialogStateFetcher.xmlHttpRequest));
                        dialogStateFetcher.xmlHttpRequest = null;
                        return;
                    }
                }
                stateError();
            });
            dialogStateFetcher.xmlHttpRequest.send(dialogStateRequest.data);
        });
    };
    DialogStateFetcher.prototype.formatResponse = function (xmlHttpRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogStateResponse, jsonResponse, dialogMessages, shortMessages, currentObjectName, currentObject, messageName, dialogPriceData_1, pricePerPax, additionalPrices, current, currentPrice, price, additionalPricesNotShown, current, priceDataItem, dialogVoucherData, nation, currentNation, countries, country;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dialogStateResponse = new DialogStateResponse(999);
                        if (xmlHttpRequest === null) {
                            return [2 /*return*/, dialogStateResponse];
                        }
                        dialogStateResponse.setState(xmlHttpRequest.status);
                        if (!dialogStateResponse.isOk()) return [3 /*break*/, 2];
                        return [4 /*yield*/, ((xmlHttpRequest.responseText.length > 0) ? JSON.parse(xmlHttpRequest.responseText) : [])];
                    case 1:
                        jsonResponse = _a.sent();
                        if (typeof jsonResponse.OfferData !== 'undefined') {
                            dialogStateResponse.setOfferKey(typeof jsonResponse.OfferData.offerNumber !== 'undefined' ?
                                jsonResponse.OfferData.offerNumber :
                                '');
                            dialogStateResponse.setHotelRoomName(typeof jsonResponse.OfferData.HotelRoomName !== 'undefined' ?
                                jsonResponse.OfferData.HotelRoomName :
                                '');
                            dialogStateResponse.setHotelRoomOpCode(typeof jsonResponse.OfferData.HotelRoomOpCode !== 'undefined' ?
                                jsonResponse.OfferData.HotelRoomOpCode :
                                '');
                            dialogStateResponse.setHotelServiceName(typeof jsonResponse.OfferData.HotelServiceName !== 'undefined' ?
                                jsonResponse.OfferData.HotelServiceName :
                                '');
                        }
                        if (typeof (jsonResponse.messages) !== 'undefined') {
                            dialogMessages = new DialogMessages();
                            // @ts-ignore
                            if (typeof (jsonResponse.messages.short) !== 'undefined') {
                                shortMessages = jsonResponse.messages.short;
                                for (currentObjectName in shortMessages) {
                                    if (shortMessages.hasOwnProperty(currentObjectName)) {
                                        currentObject = shortMessages[currentObjectName];
                                        for (messageName in currentObject) {
                                            if (currentObject.hasOwnProperty(messageName)) {
                                                dialogMessages.addMessage(currentObjectName + '[' + messageName + ']', currentObject[messageName]);
                                            }
                                        }
                                    }
                                }
                            }
                            // @ts-ignore
                            if (typeof (jsonResponse.messages.long) !== 'undefined') {
                                dialogMessages.setLongText(jsonResponse.messages.long);
                            }
                            dialogStateResponse.setDialogMessages(dialogMessages);
                        }
                        dialogStateResponse.setGeoPayment(typeof (jsonResponse.Purchaser) === 'undefined' || typeof (jsonResponse.Purchaser.Land) === 'undefined' || jsonResponse.Purchaser.Land === 'D' || jsonResponse.Purchaser.Land === 'A');
                        if (typeof (jsonResponse.PriceData) !== 'undefined') {
                            dialogPriceData_1 = new DialogPriceData();
                            pricePerPax = typeof (jsonResponse.PriceData.pricePerPax) !== 'undefined' ?
                                jsonResponse.PriceData.pricePerPax :
                                [];
                            pricePerPax.forEach(function (current, key) {
                                // @ts-ignore
                                var currentPrice = typeof current['_total'] !== 'undefined' ? current['_total'] : '';
                                dialogPriceData_1.addPricePerPaxData({
                                    Amount: currentPrice,
                                    SumOfAmount: currentPrice,
                                    SumOfAmountOriginal: currentPrice
                                });
                            });
                            additionalPrices = typeof (jsonResponse.PriceData.additionalPrices) !== 'undefined' ?
                                jsonResponse.PriceData.additionalPrices :
                                [];
                            for (current in additionalPrices) {
                                if (additionalPrices.hasOwnProperty(current)) {
                                    currentPrice = additionalPrices[current].Values;
                                    for (price in currentPrice) {
                                        if (currentPrice.hasOwnProperty(price)) {
                                            dialogPriceData_1.addDialogPriceData(current, currentPrice[price]);
                                        }
                                    }
                                }
                            }
                            dialogPriceData_1.setTotalPrice(jsonResponse.PriceData.endPriceTotal);
                            dialogPriceData_1.setFloatInside(jsonResponse.PriceData.FloatInside);
                            dialogPriceData_1.setAdditionalFloatInside(jsonResponse.PriceData.AdditionalFloatInside);
                            additionalPricesNotShown = typeof (jsonResponse.PriceData.additionalPricesNotShown) !== 'undefined' ?
                                jsonResponse.PriceData.additionalPricesNotShown :
                                [];
                            for (current in additionalPricesNotShown) {
                                if (additionalPricesNotShown.hasOwnProperty(current)) {
                                    priceDataItem = {
                                        Name: current,
                                        Class: current,
                                        Amount: additionalPricesNotShown[current],
                                        SumOfAmount: additionalPricesNotShown[current],
                                        Count: 1
                                    };
                                    dialogPriceData_1.addSummaryPriceData(current, priceDataItem);
                                }
                            }
                            dialogStateResponse.setDialogPriceData(dialogPriceData_1);
                        }
                        if (typeof (jsonResponse.VoucherData) !== 'undefined' && typeof (jsonResponse.VoucherData.einreisebestimmung) !== 'undefined') {
                            dialogVoucherData = new DialogVoucherData();
                            for (nation in jsonResponse.VoucherData.einreisebestimmung) {
                                currentNation = jsonResponse.VoucherData.einreisebestimmung[nation];
                                countries = new Map();
                                for (country in currentNation) {
                                    countries.set(country, currentNation[country]);
                                }
                                dialogVoucherData.addNation(nation, countries);
                            }
                            dialogStateResponse.setDialogVoucherData(dialogVoucherData);
                        }
                        if (typeof (jsonResponse.PackageTravelDirective) !== 'undefined') {
                            dialogStateResponse.setPackageTravelDirective(jsonResponse.PackageTravelDirective);
                        }
                        if (typeof (jsonResponse.PreContractInformation) !== 'undefined') {
                            dialogStateResponse.setPreContractInformation(jsonResponse.PreContractInformation);
                        }
                        if (typeof (jsonResponse.CouponCode) !== 'undefined') {
                            dialogStateResponse.setCouponCode(jsonResponse.CouponCode);
                        }
                        if (typeof (jsonResponse.TransactionData) !== 'undefined') {
                            dialogStateResponse.setTransactionData(jsonResponse.TransactionData);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, dialogStateResponse];
                }
            });
        });
    };
    return DialogStateFetcher;
}());
export default DialogStateFetcher;
